import Dialog from "../../atoms/dialog";
import { Button, Typography, Box, Grid } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { marginBottom } from '../../../config/styles';
import { getMessages } from '../../../store/constructs/messages/selectors';

const ReusedMessageAlert = (props) => {
    const { onContinue, onClose, messageId } = props;

    const message = useSelector(getMessages).find(item => item.id === messageId);
   
    const handleClose = () => {
        onClose(false);
    }

    return (
        <Dialog
            title={"Alert"}
            open={true}
            handleClose={handleClose}
        >
            <Grid >
                <Grid style={marginBottom}>
                    <Fragment>
                        <Typography> The event type {message.name} is used in  multiple events. Are you sure you want to continue the action ?</Typography>
                    </Fragment>
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <Button color="secondary" variant="outlined" style={{ marginLeft: 10 }} onClick={handleClose} > CLOSE </Button>
                    <Button color="primary" variant="contained" style={{ marginLeft: 10 }} onClick={onContinue}> CONTINUE </Button>
                </Grid>        
             </Grid>
        </Dialog >
    )
}

export default ReusedMessageAlert;